<div class="tab-pane" role="tabpanel" id="permisos_recep">
        <fieldset id="agregar_perm_resol" class="">
            <div class="step_section">
                <h3 class="form-signin-heading"><strong>Permisos y Recepciones Anteriores</strong> <br>(En caso de tratarse de Ampliaciones construidas antes del 31/07/1959)</h3>
                <hr />
                <div class="row" id="row">
                    <div class="col-md-12" id="content">
                        <form [formGroup]="form">
                            <div class="form-horizontal">
                                <div class="form-group" align="left" style="padding-bottom: 20px">  
                                    <div>
                                        <label for="permiso" class="col-md-2" style="padding-top: 20px;">Permiso</label>
                                        <div class="col-md-2">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="Permiso" id="permiso" name="permiso" formControlName="permiso" >
                                            </mat-form-field>
                                        </div>
                                    </div>
    
                                </div>
                                <div class="form-group" align="left" style="padding-bottom: 20px">
                                    <label for="fecha" class="col-md-2" style="padding-top: 20px;">Fecha permiso</label>
                                    <div class="col-md-2">
                                        <div class="col-md-2" style="padding-left: 0px">
                                            <mat-form-field class="dateinput" style="width: 145px;">
                                                <input matInput [matDatepicker]="dp3" [max]="maxDate" formControlName="fecha" disabled>
                                                <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-2"></div>
                                    <label for="numero" class="col-md-2" style="padding-top: 20px;">N&uacute;mero permiso</label>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px; ">
                                            <input matInput placeholder="N&uacute;mero Permiso" id="numero" name="numero" formControlName="numero" >
                                            <mat-error *ngIf="form.controls['total_predios_apro'].hasError('pattern')">
                                                Solo se permiten caracteres <strong>numéricos</strong>
                                            </mat-error>  
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="form-group" align="left" style="padding-bottom: 20px">
                                    <label for="recepcion" class="col-md-2" style="padding-top: 20px;">N° Recepción</label>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="Recepcion Nro" id="recepcion" name="recepcion" formControlName="recepcion" >
                                            <mat-error *ngIf="form.controls?.recepcion.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2"></div>
                                    <label for="superficie" class="col-md-2" style="padding-top: 20px;">Superficie M2</label>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="Superficie M2" id="superficie" name="superficie" formControlName="superficie" >
                                            <span matSuffix>m²</span>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="form-group" align="left" style="padding-bottom: 20px">
                                    <label for="fecha_recep" class="col-md-2" style="padding-top: 20px;">Fecha Recepción</label>
                                    <div class="col-md-2">
                                        <mat-form-field class="dateinput" style="width: 145px;">
                                            <input matInput [matDatepicker]="dp4"  [max]="maxDate" formControlName="fecha_recep" disabled>
                                            <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                                            <mat-datepicker #dp4 disabled="false"></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div align="center" class="col-md-12">
                                        <button mat-raised-button color="primary" style="margin-top: 15px" id="ingreso_permiso" (click)="add_permisos_recep()">
                                                    Agregar Permisos
                                                <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                            </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="datatable_antecedentes">
                            <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                                <ngx-datatable-column>
                                    <ng-template ngx-datatable-header-template>
                                        <span>PERMISO</span>
                                    </ng-template>
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{row.permiso}}
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column>
                                    <ng-template ngx-datatable-header-template>
                                        <span>PERMISO NUM</span>
                                    </ng-template>
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{row.numero}}
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column>
                                    <ng-template ngx-datatable-header-template>
                                        <span>FECHA</span>
                                    </ng-template>
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{row.fecha}}
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column>
                                    <ng-template ngx-datatable-header-template>
                                        <span>SUPERFICIE</span>
                                    </ng-template>
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{row.superficie}}
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column>
                                    <ng-template ngx-datatable-header-template>
                                        <span>RECEPCION</span>
                                    </ng-template>
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{row.recepcion}}
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column>
                                    <ng-template ngx-datatable-header-template>
                                        <span>FECHA</span>
                                    </ng-template>
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{row.fecha_recep}}
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column>
                                    <ng-template ngx-datatable-header-template>
                                        <span>OPCIONES</span>
                                    </ng-template>
                                    <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                        <span (click)="get_permisos_recep(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                                        <span (click)="delete_permisos_recep(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                    </ng-template>
                                </ngx-datatable-column>
    
                            </ngx-datatable>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <!--Modal-->
        <ng-template #openModal>
            <h2 mat-dialog-title>Ingresar informaci&oacute;n de los Permisos</h2>
            <mat-dialog-content>
    
                <div class="form-horizontal">
                    <div class="alert alert-info" role="alert">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <strong> Permiso para el que se solicita esta recepcion</strong>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="permiso">Permiso</label>
                        <div class="col-md-6">
                            <input id="permiso" name="permiso" type="text" placeholder="permiso" class="form-control input-md" [(ngModel)]="temp_perm.permiso">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="numero">Permiso Numero</label>
                        <div class="col-md-6">
                            <input id="numero" name="numero" type="text" placeholder="numero" class="form-control input-md" [(ngModel)]="temp_perm.numero">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="fecha">Fecha</label>
                        <div class="col-md-6">
                            <input id="fecha" name="fecha" type="text" placeholder="fecha" class="form-control input-md" [(ngModel)]="temp_perm.fecha">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="superficie">Superficie</label>
                        <div class="col-md-6">
                            <input id="superficie" name="superficie" type="text" placeholder="superficie" class="form-control input-md" [(ngModel)]="temp_perm.superficie">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="recepcion">Recepcion</label>
                        <div class="col-md-6">
                            <input id="recepcion" name="recepcion" type="text" placeholder="recepcion" class="form-control input-md" [(ngModel)]="temp_perm.recepcion">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="superficie">Superficie</label>
                        <div class="col-md-6">
                            <input id="superficie" name="superficie" type="text" placeholder="superficie" class="form-control input-md" [(ngModel)]="temp_perm.superficie">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_permiso" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
                <button mat-raised-button color="primary" id=" ingreso_permiso_recep" (click)="savepermisos_recep() ">Ingresar Permiso <i class="fa fa-user-o " aria-hidden="true "></i></button>
    
            </mat-dialog-actions>
        </ng-template>
    </div>

    <ng-template #openModalNODATA>
        <h2 mat-dialog-title>Ingrese datos</h2>
        <mat-dialog-content>
           No ingreso ningun dato del permiso.
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
        </mat-dialog-actions>
    </ng-template>
    

    <div class="separator"></div>